<style lang="less">
.dcAward {
  text-align: center;
  background: linear-gradient(0deg, #ca2f13 0%, #e75816 100%);
  font-size: 0.24rem;
  color: #fceed0;
  p {
    margin: 0;
    padding: 0.05rem 0;
  }
  &__logo {
    .k-user-logo {
      margin: 0 auto;
      width: 0.64rem;
      height: 0.64rem;
    }
  }

  &__info {
    text-align: center;
    width: 5rem;
    margin: 0 auto;
    padding: 0.1rem 0;
    font-size: 0.24rem;
  }
}
</style>
<template>
  <div v-if="giveUser" class="dcAward">
    <div class="dcAward__logo">
      <k-user-logo
        v-if="takeUser"
        :src="takeUser.logoSm"
        :lv="takeUser.lvKey"
        size="small"
      />
      <k-user-logo
        v-else
        src="https://imgcdn-prd.pydp888.com/file/0/1/200003/20201028/46d4a35ab225281913d2eb94399e0f80.4_wenhao.png"
        lv="user"
        size="small"
      />
    </div>
    <div v-if="takeUid > 0" class="dcAward__info">
      <p>编码：{{ awardId }} <span>已领取</span></p>
      <p v-if="isGiver">
        已被用户<span v-if="takeUser"> {{ takeUser.nick }} </span>领取
      </p>
      <p v-else-if="takeUid === myUid">
        领取的第二个工作日开通权限，点击【我的软件】前往下载软件进行使用。
      </p>
      <p v-else if="myUid > 0">
        哎呀，您来晚一步，该福利已被领取啦！请前往活动页面参加其他活动，有机会获取更多福利哦！
      </p>
    </div>
    <div v-else class="dcAward__info">
      <p>编码：{{ awardId }} <span>未领取</span></p>
      <p v-if="isGiver">仅限非王者财经用户注册领取</p>
      <p v-else-if="myUid > 0">
        仅限通过本页面注册的新用户才能领取！但您可以邀请新人获得更多福利哦！
      </p>
      <p v-else>仅限非王者财经用户注册领取</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('laxin/dc', [
      'awardId',
      'myUid',
      'giveUid',
      'takeUid',
      'giveUser',
      'takeUser',
      'isGiver'
    ])
  }
}
</script>
